export class ProspectResidenceLookupRequest {
  postcode?: number;
  districtId?: number;
  streetId?: number;
  name?: string;
  surname?: string;
  rawName?: string;
  mobilePhone?: string;
}
